import userSettings from "@/_mixins/user-settings-mixin"

export default {
    mixins : [userSettings],
    data()
    {
        return {
            bookmarked : false,
        }
    },
}